
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 12C18 12.55 18.45 13 19 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H19C18.45 11 18 11.45 18 12Z' fill='#323232'/><path d='M16.59 16.82C16.26 17.26 16.35 17.87 16.79 18.19C17.32 18.58 17.88 19 18.41 19.4C18.85 19.73 19.47 19.64 19.79 19.2C19.79 19.19 19.8 19.19 19.8 19.18C20.13 18.74 20.04 18.12 19.6 17.8C19.07 17.4 18.51 16.98 17.99 16.59C17.55 16.26 16.93 16.36 16.6 16.8C16.6 16.81 16.59 16.82 16.59 16.82Z' fill='#323232'/><path d='M19.8098 4.81004C19.8098 4.80004 19.7998 4.80004 19.7998 4.79004C19.4698 4.35004 18.8498 4.26005 18.4198 4.59005C17.8898 4.99005 17.3198 5.41004 16.7998 5.81004C16.3598 6.14004 16.2798 6.76005 16.6098 7.19005C16.6098 7.20005 16.6198 7.20005 16.6198 7.21005C16.9498 7.65005 17.5598 7.74004 17.9998 7.41004C18.5298 7.02004 19.0898 6.59004 19.6198 6.19004C20.0498 5.87004 20.1298 5.25004 19.8098 4.81004Z' fill='#323232'/><path d='M8 9H4C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18V15H8L13 18V6L8 9Z' fill='#323232'/><path d='M15.5 12C15.5 10.67 14.92 9.47002 14 8.65002V15.34C14.92 14.53 15.5 13.33 15.5 12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-campaign`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCampaign

    ```js
    <b-new-b-icon-campaign />
    ```
</docs>


